import { slugify } from './slugify'

export const SITE_ORIGIN = 'https://pulpitcabs.com'

/**
 * Every indexable path ends in a slash.
 *
 * Prerendered pages are written to build/<path>/index.html. nginx serves a
 * directory only after a 301 onto the trailing-slash form, so the slash version
 * is the URL that resolves in one hop. Pages we have not prerendered fall
 * through to the SPA shell and render identically either way, which keeps a
 * single URL shape across the whole site.
 */
export const withTrailingSlash = (path) => {
  if (!path) return '/'
  const [pathname] = path.split(/[?#]/)
  if (pathname.endsWith('/')) return pathname
  return `${pathname}/`
}

export const routePath = (from, to) =>
  `/routes/${slugify(from)}-to-${slugify(to)}-cab/`

export const cityPath = (city) => `/cities/${slugify(city)}/`

export const absoluteUrl = (path) => `${SITE_ORIGIN}${withTrailingSlash(path)}`
